import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import ResourceManager from '@/Management/ResourceManager';

export default class ErgNameBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.ergName = {
            init: (node: HTMLElement, valueAccessor: () => any) => {
                const ergName = ko.unwrap(valueAccessor());
                ErgNameBinding.setErgName(ergName, node);
            }, update: (node: HTMLElement, valueAccessor: () => any) => {
                const ergName = ko.unwrap(valueAccessor());
                ErgNameBinding.setErgName(ergName, node);
            }
        };
    }

    private static setErgName(ergName: string, node: HTMLElement) {
        const $element = $(node);
        const resource = ResourceManager.getInstance().loadResource(ergName, true);
        if (_.isString(resource)) {
            $element.text(resource);
        } else {
            const deferred = resource;

            deferred.then((resourceResult: string) => {
                $element.text(resourceResult);
            });
        }
    }
}